/**
 * AI模型配置
 * 仅用于前端模型列表展示，API密钥由后端管理
 */

// 文本模型配置 - 指定显示的模型列表
export const TEXT_MODELS_CONFIG = [
  { id: 'qwen3-max', name: 'Qwen3 Max', company: '阿里云' },
  { id: 'qwen3.6-plus', name: 'Qwen3.6 Plus', company: '阿里云' },
  { id: 'deepseek-v3.2', name: 'DeepSeek V3.2', company: 'DeepSeek' },
  { id: 'glm-4.7', name: 'GLM-5', company: '智谱AI' },
  { id: 'MiniMax-M2.5', name: 'MiniMax-M2.5', company: 'MiniMax' },
  { id: 'kimi-k2.5', name: 'Kimi K2.5', company: '月之暗面' },
];

// 视觉模型配置 - 指定显示的视觉模型列表
export const VISION_MODELS_CONFIG = [
  { id: 'glm-4v', name: 'GLM-4V', company: '智谱AI' },
  { id: 'MiniMax-VL', name: 'MiniMax-VL', company: 'MiniMax' },
  { id: 'kimi-vl', name: 'Kimi-VL', company: '月之暗面' },
  { id: 'qwen-vl-plus', name: 'Qwen-VL Plus', company: '阿里云' },
  { id: 'deepseek-vl', name: 'DeepSeek-VL', company: 'DeepSeek' },
];

// 获取模型显示名称
export const getModelDisplayName = (modelId: string): string => {
  const allModels = [...TEXT_MODELS_CONFIG, ...VISION_MODELS_CONFIG];
  const model = allModels.find(m => m.id === modelId);
  if (model) {
    return `${model.name} (${model.company})`;
  }
  return modelId;
};

// 直接返回配置中的文本模型ID列表（不依赖后端返回，确保精确匹配）
export const filterModels = (_models?: string[]): string[] => {
  return TEXT_MODELS_CONFIG.map(m => m.id);
};

// 直接返回配置中的视觉模型ID列表（不依赖后端返回，确保精确匹配）
export const filterVisionModels = (_models?: string[]): string[] => {
  return VISION_MODELS_CONFIG.map(m => m.id);
};
